import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { useImportImageNewDesign } from 'hooks/index';

function Outcome({ outcome }) {
  const odds = outcome && outcome.odds;
  const decOdds = outcome && outcome.decOdds;
  const betstop = Boolean(outcome && outcome.betstop);

  const [prevOdds, setPrevOdds] = useState(decOdds);
  const [newOdds, setNewOdds] = useState(decOdds);

  const trendUpIcon = useImportImageNewDesign('trend-up.svg');
  const trendDownIcon = useImportImageNewDesign('trend-down.svg');

  useEffect(() => {
    if (betstop || decOdds === null || decOdds === undefined) {
      setNewOdds(decOdds);
      setPrevOdds(decOdds);
    }
  }, [betstop, decOdds]);

  useEffect(() => {
    if (betstop || decOdds === null || decOdds === undefined) return undefined;
    let timer;
    setNewOdds(decOdds);
    timer = setTimeout(() => {
      setPrevOdds(decOdds);
      timer = null;
    }, 5000);
    return () => {
      if (timer) {
        clearTimeout(timer);
        setPrevOdds(decOdds);
      }
    };
  }, [decOdds, betstop]);

  let trend = '';

  const hasValidOdds = !betstop && decOdds !== null && decOdds !== undefined;

  if (hasValidOdds && newOdds === decOdds) {
    if (prevOdds > newOdds) {
      trend = 'down';
    } else if (prevOdds < newOdds) {
      trend = 'up';
    }
  }

  return (
    <div className='space-y-[0.3vw]'>
      <div className='relative flex items-center justify-center'>
        <span
          className={`pointer-events-none absolute left-1/2 transition-opacity duration-150 ease-out ${
            trend ? 'opacity-100' : 'opacity-0'
          } ${
            trend === 'up'
              ? '-translate-x-[calc(100%+2vw)]'
              : trend === 'down'
                ? 'translate-x-[calc(2vw)]'
                : ''
          }`}
        >
          {trend === 'up' && (
            <img src={trendUpIcon} alt='up' className='h-[0.9vw] w-[0.9vw]' />
          )}
          {trend === 'down' && (
            <img src={trendDownIcon} alt='down' className='h-[0.9vw] w-[0.9vw]' />
          )}
        </span>
        <span className='fs-20 font-second--bold color-theme-highlight'>
          {betstop ? '-' : (odds || '-')}
        </span>
      </div>
      <div className='uppercase fs-18 font-second--medium text-white text-center'>
        {(outcome && (outcome.abbr || outcome.name)) || ''}
      </div>
    </div>
  );
}

Outcome.propTypes = {
  outcome: PropTypes.object.isRequired,
};

export default Outcome;
